import { gql } from '@apollo/client'

export default gql`
  fragment LibraryPostVideoBlockComponent on LibraryPostVideo {
    id
    slug
    type
    title
    image {
      url
      # blurhash
    }
    topics {
      nodes {
        id
        slug
        title
      }
    }
    description
  }
`
